import React from "react";
import { Instagram, ArrowRight, ArrowUpRight } from "lucide-react";
import { Btn, Reveal } from "./ui";
import { useSettings } from "../../context/SettingsContext";
import { useContact } from "../../context/ContactContext";

export const FinalCta = () => {
  const { settings } = useSettings();
  const { openTally } = useContact();
  const handle = settings?.instagram_handle || "@bishal.keyframes";
  const profile = settings?.instagram_url || "#";

  return (
    <section id="contact" className="relative py-28 md:py-40 px-6 md:px-10 overflow-hidden">
      <div
        className="pointer-events-none absolute left-1/2 top-1/3 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[130px]"
        style={{ background: "var(--accent-color)", opacity: 0.12 }}
      />
      <div className="relative mx-auto max-w-5xl">
        <div className="text-center">
          <Reveal>
            <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight leading-[1.05]">
              Ready to make your content worth watching?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
              Let's build something people actually want to watch.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-12 flex justify-center">
              <Btn as="button" onClick={openTally} variant="solid" className="!px-8 !py-4 text-base" data-testid="final-start-project">
                Start a Project <ArrowRight size={18} />
              </Btn>
            </div>
          </Reveal>
        </div>

        {/* Fastest way to start — Instagram DM */}
        <Reveal delay={0.1}>
          <div
            className="mt-16 md:mt-20 rounded-2xl border p-8 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8"
            style={{ borderColor: "var(--border-color)", background: "var(--surface-color)" }}
            data-testid="dm-section"
          >
            <div>
              <span className="text-xs uppercase tracking-[0.35em]" style={{ color: "var(--accent-color)" }}>
                Fastest way to start
              </span>
              <p className="mt-4 font-heading text-2xl md:text-3xl font-medium tracking-tight">
                Let's talk on Instagram.
              </p>
              <a
                href={profile}
                target="_blank"
                rel="noreferrer"
                data-testid="dm-handle"
                className="mt-2 inline-flex items-center gap-1.5 text-base transition-colors duration-300 hover:text-[var(--accent-color)]"
                style={{ color: "var(--text-secondary)" }}
              >
                {handle}
                <ArrowUpRight size={15} />
              </a>
            </div>

            <a
              href={profile}
              target="_blank"
              rel="noreferrer"
              data-testid="dm-message-me"
              className="group inline-flex shrink-0 items-center justify-center gap-2.5 px-7 py-4 text-sm font-medium transition-colors duration-300 hover:text-[var(--accent-color)] hover:border-[var(--accent-color)] border"
              style={{ borderColor: "var(--border-color)", borderRadius: "var(--btn-radius)" }}
            >
              <Instagram size={18} />
              Message Me
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
